<template>
  <header
    ref="header"
    :class="{'header--active' : drawerActive}"
  >
    <slot
      :drawerActive="drawerActive"
      :toggleDrawer="toggleDrawer"
      :scrollToFooter="scrollToFooter"
    />
  </header>
</template>

<script>
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from 'gsap/ScrollSmoother';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

export default {
  data() {
    return {
      drawerActive: false,
    }
  },
  mounted() {
    setTimeout(() => {
      ScrollSmoother.create({
        content: "#smooth-content",
        smooth: 1.2,
        effects: true,
      });
    }, 50);
  },
  methods: {
    toggleDrawer() {
      this.drawerActive = !this.drawerActive;

      if (this.drawerActive == true) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    scrollToFooter() {
      const scrollHeight = document.body.scrollHeight;
      window.scrollTo(0, scrollHeight);
    },
  }
}
</script>